import { APP_TYPE } from 'common/constants/Constants';
import oneidTencentDocLogo from 'common/static/images/logo/oneidTencentDocLogo.png';
import { APP_LOGO_TYPE } from 'idpBase/Constants';
import { APPROVAL_RESULT_TYPES } from 'idpBase/http/services/AuthApi';

export enum CONTENT {
  /** 部门邀请 */
  DEPT_INVITATION = 'DEPT_INVITATION',
  /** 激活邀请主要内容 */
  INVITING = 'INVITING',
  /** 移动端手机号和验证码输入页 | 邮箱设置密码 */
  MOBILE_VERIFY = 'MOBILE_VERIFY',
  /** 邀请链接失效、加入成功、已拒绝、已在该企业 */
  RESULT_PAGE = 'RESULT_PAGE',
  /** 输入邀请码页面 */
  CODE = 'CODE',
  /** 立即跳转的 cookie 失效时，二次确认手机号的页面 */
  MOBILE_REVERIFY = 'MOBILE_REVERIFY',
}

/** 短信邀请状态枚举 */
export enum RESULT_TYPES {
  /** 初始状态 */
  INIT = 0,
  /** 已成功 */
  JOIN_SUCCESS = 1,
  /** 已拒绝 */
  REFUSED = 2,
  /** 已失效 */
  EXPIRED = 3,
  /** 失败 */
  FAIL = 4,
  /** 审核中 */
  REVIEW = 5,
}

/** 状态结果接口返回和前端存储 */
export const RESULT_MAP = {
  [APPROVAL_RESULT_TYPES.INITIALIZED]: RESULT_TYPES.INIT,
  [APPROVAL_RESULT_TYPES.PENDING]: RESULT_TYPES.REVIEW,
  [APPROVAL_RESULT_TYPES.ACCEPTED]: RESULT_TYPES.JOIN_SUCCESS,
  [APPROVAL_RESULT_TYPES.REJECTED]: RESULT_TYPES.FAIL,
};

export const APP_LOGO_INFO = new Map([
  [
    APP_LOGO_TYPE.ONE_ID,
    {
      logoUrl: `${window.ONEID_PUBLIC_CDN_URL}/images/logo/oneid-logo-text.png`,
      defaultOrgLogo: `${window.ONEID_PUBLIC_CDN_URL}/images/account-logo.png`,
    },
  ],
  [
    APP_LOGO_TYPE.YUANBAO_BIZ,
    {
      logoUrl: `${window.ONEID_PUBLIC_CDN_URL}/images/logo/yb-brand-new.png`,
      defaultOrgLogo: `${window.ONEID_PUBLIC_CDN_URL}/images/default-enterprise-avatar.png`,
    },
  ],
  [
    APP_LOGO_TYPE.DOC,
    {
      logoUrl: oneidTencentDocLogo,
      defaultOrgLogo: `${window.ONEID_PUBLIC_CDN_URL}/images/account-logo.png`,
    },
  ],
]);

export enum INVITE_FROM {
  MOBILE = 'Mobile',
  EMAIL = 'Email',
}

export const VERIFY_CODE_ERROR = {
  E0010028: '验证码错误，请重新填写',
};

/** cookie 失效的错误标识，需要再次验证手机号 */
export const AUTH_INVALID_ERROR_CODE = 'E0010476';

export const EMAIL_SET_PWD_ERROR_CODE = 'E0010353';

export const EXPIRE_CODES = ['E0010002', 'E0010357'];

/** 验证码错误的场景 */
export const WRONG_CODE_ERROR_CODE_LIST = ['E0520009', 'E0520010', 'E0520011', 'E0520012'];

/** 停留在申请页的报错，值为空时使用接口返回 */
export const JOIN_DEPT_ERROR = {
  E0010021: '',
  E0520006: '',
  E0520007: '',
  E0520008: '',
  E0200004: '该手机号已加入，无需重复申请',
};

/** 二次验证的报错信息覆盖 */
export const REVERIFY_CODE_ERROR = {
  E0200001: '该手机号在“{name}”下无账号，请更换手机号后再试',
  E0010035: '该手机号在“{name}”下账号已被停用，请联系管理员',
  E0010344: '该手机号在“{name}”下账号已被封禁，请联系管理员',
};

/** 获取邀请信息的报错覆盖 */
export const INVITATION_INFO_ERROR = {
  E0200001: '该账号已被删除，请更换手机号后再试',
  E0010035: '该账号已被停用，请联系管理员',
  E0010344: '该账号已被封禁，请联系管理员',
};

/** 区分元宝、会议等有不同文案的报错码 */
export const DIFF_APP_ERROR_CODE = ['E0400014'];

/** 不同应用对于企业的定义 */
export const APP_TAG = {
  [APP_TYPE.ONEID]: '企业',
  [APP_TYPE.YUANBAO]: '团队',
  [APP_TYPE.DOC]: '组织',
};
